import { render } from "./AppDataBlockList.vue?vue&type=template&id=a6e30302&scoped=true"
import script from "./AppDataBlockList.vue?vue&type=script&lang=js"
export * from "./AppDataBlockList.vue?vue&type=script&lang=js"

import "./AppDataBlockList.vue?vue&type=style&index=0&id=a6e30302&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e30302"]])

export default __exports__